import { __decorate, __metadata } from "tslib";
import { Injectable } from 'angular-ts-decorators';
var MarketLocaleInterceptor = (function () {
    function MarketLocaleInterceptor($q, localeService) {
        var _this = this;
        this.$q = $q;
        this.localeService = localeService;
        this.request = function (config) {
            if (config.url.indexOf('marketLocale=') > -1) {
                return config || _this.$q.when(config);
            }
            var isScApiRequest = config.method === 'GET' && config.url.includes('/support/api');
            if (isScApiRequest && !config.url.startsWith(_this.localeService.localePrefix())) {
                var prefix = _this.localeService.localePrefix();
                config.url = config.url.startsWith('/') ? "" + prefix + config.url : prefix + "/" + config.url;
            }
            return config || _this.$q.when(config);
        };
        this.response = function (response) {
            return response || _this.$q.when(response);
        };
    }
    MarketLocaleInterceptor.$inject = ['$q', 'localeService'];
    MarketLocaleInterceptor = __decorate([
        Injectable('MarketLocaleInterceptor'),
        __metadata("design:paramtypes", [Function, Object])
    ], MarketLocaleInterceptor);
    return MarketLocaleInterceptor;
}());
export { MarketLocaleInterceptor };
